import { Icon, Popconfirm } from "antd";
import React from "react";

import removableStyles from "./removableItem.module.scss";
import styles from "../table/table.module.scss";

const RemovableItem = ({
  itemText,
  deleteConfirmText,
  onConfirm,
  allowDelete,
  single,
  itemComponent,
  lastWordStyle
}) => {
  const singleClassName = single ? removableStyles.single : "";
  const prevText =
    itemText && itemText.trim().split(" ").slice(0, -1).join(" ") + " ";
  const lastWord = itemText && itemText.trim().split(" ").pop();
  return (
    <div
      className={
        styles.tdItem + " " + removableStyles.cellName + " " + singleClassName
      }
    >
      <span
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {itemComponent || null}
        {prevText}
        <div className={removableStyles.noWrap}>
          <span className={removableStyles.text} style={lastWordStyle}>{lastWord}</span>
           <span className={removableStyles.icon}>
            {allowDelete && (
              <Popconfirm
                className={removableStyles.deleteButton}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                title={
                  <div className={removableStyles.deleteConfirmText}>
                    {deleteConfirmText}
                  </div>
                }
                okText={"Да"}
                onConfirm={onConfirm}
              >
                <Icon
                  type="minus-circle"
                  className={"dspx-danger-button " + removableStyles.deleteIcon}
                />
              </Popconfirm>
            )}{" "}
          </span>

        </div>
      </span>
    </div>
  );
};

export default RemovableItem;
